module.exports = __webpack_public_path__ + "img/guang.ca9c02b4.png";